import { render, staticRenderFns } from "./Marking.vue?vue&type=template&id=6d6a0852&scoped=true"
import script from "./Marking.vue?vue&type=script&lang=js"
export * from "./Marking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6a0852",
  null
  
)

export default component.exports